$(function () {

	//メインビジュアルスライドショー
	var swiper = new Swiper(".mv_swiper", {
		loop: true,
		slidesPerView: 'auto',
		// centeredSlides: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});

	//タブ切り替え
	$(".tab_label").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_label").removeClass("active");
		$(this).parent().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parent().next().find(".tab_panel").eq($th).addClass("active");
	});

	//ポップアップ
	$('.popup-modal-single').magnificPopup({
		type: 'inline',
		preloader: false,
		removalDelay: 300,
	});

});